import { render, staticRenderFns } from "./conversation.vue?vue&type=template&id=01fd4a6d&scoped=true&"
import script from "./conversation.vue?vue&type=script&lang=js&"
export * from "./conversation.vue?vue&type=script&lang=js&"
import style0 from "./conversation.vue?vue&type=style&index=0&id=01fd4a6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd4a6d",
  null
  
)

export default component.exports